<template>
	<div>
		<el-row :gutter="10">
			<!-- 左边 -->
			<el-col :xs="0" :sm="15" :md="15" :lg="15" :xl="15" :offset="2">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item :to="{ path: '/newslist/id/3' }" v-if="content.typelist == 0" style="cursor: pointer;">采购中心</el-breadcrumb-item>
					  <el-breadcrumb-item :to="{ path: '/newslist/id/5' }" v-else-if="content.typelist == 1" style="cursor: pointer;">招投标常识</el-breadcrumb-item>
					   <el-breadcrumb-item :to="{ path: '/newslist/id/6' }" v-else="content.typelist == 2" style="cursor: pointer;">物流常识</el-breadcrumb-item>
					  <el-breadcrumb-item>{{content.title}}</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="content">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="title">{{content.title}}</div>
						<div class="subtitle"> <i class="el-icon-lock"></i>来源： {{content.author}} <i class="el-icon-time"></i> 更新时间：{{$utils.timestampToTimes(content.createtime*1000)}}</div>
						<div class="details" v-html="content.content"></div>
						<div class="tips"><span>【免责声明】</span>：本文由物流运输招标平台用户攥写或转载并发布，转载目的在于传递更多信息，物流运输招标仅提供信息发布平台。文章内容仅代表本文作者或原作者个人观点，不代表物流运输招标立场。转载需注明来源及作者姓名。如内容侵犯到您的权益及版权问题，请告知客服，经本平台核实后立即删除。</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
			<!-- 右边 -->
			<el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5">
				<div class="grid-content first">
					<el-carousel :interval="6000" arrow="never">
						<el-carousel-item v-for="item in bannerTop" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content second">
					<div class="listHeader">
						采购中心
					</div>
					<el-card class="box-card">
					  <div v-for="o in caigoulist.slice(0,4)" :key="o.Id" class="text item" @click="$router.push('/newsdetails/id/'+o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>  
				</div>
				<div class="grid-content third">
					<el-carousel :interval="5000" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content four">
					<div class="listHeader">
						散单需求
					</div>
					<el-card class="box-card">
					  <div v-for="o in sandanlist.slice(0,4)" :key="o.Id" class="text item" @click="$router.push('/details/id/'+o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>    
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row style="margin-bottom: 30px;margin-top: -20px;">
			<!-- 左边 -->
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			  <div class="grid-content left">
				  <div class="content">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="title" style="font-size: 1rem;">{{content.title}}</div>
						<div class="subtitle" style="font-size: 0.5rem;"> <i class="el-icon-lock"></i>来源： {{content.author}} <i class="el-icon-time"></i> 更新时间：{{$utils.timestampToTimes(content.createtime*1000)}}</div>
						<div class="details" v-html="content.content"></div>
						<div class="tips"><span>【免责声明】</span>：本文由物流运输招标平台用户攥写或转载并发布，转载目的在于传递更多信息，物流运输招标仅提供信息发布平台。文章内容仅代表本文作者或原作者个人观点，不代表物流运输招标立场。转载需注明来源及作者姓名。如内容侵犯到您的权益及版权问题，请告知客服，经本平台核实后立即删除。</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name:'newsdetails',
	metaInfo() {
	  return {
		title: this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
  data() {
    return {
		id:0,
		metaName: "",
		metaKeywords: "",
		metaDecs: "",
		loading: false,
		post: null,
		error: null,
		keywords:'',
		value: '',
		domain:this.$utils.httpUrl,
		bannerTop:[],
		bannerMiddle:[],
		caigoulist:[],
		sandanlist:[],
		content:{id:1,title:"招标公告详情",source:"招标网",updatetime:"2023-05-28",details:"招标公告详情招标公告详情招标公告详情招标公告详情招标公告详情招标公告详情"}
	}
  },
  mounted() {
  	this.id = this.$route.params.id
  	this.getDetails()
  	this.$axios({
  		url:this.$utils.httpApi + 'index/webconfig'
  	}).then(res=>{
  		this.title = res.data.data.webtitle
  		this.metaDecs = res.data.data.webdescription
  		this.metaKeywords = res.data.data.webkeywords
  	})
  },
  created() {
	 this.getBanners()
	 this.getCaigou()
	 this.getZhaobiao() 
    // // watch 路由的参数，以便再次获取数据
    // this.$watch(
    //   () => this.$route.params,
    //   () => {
    //     this.fetchData()
    //   },
    //   // 组件创建完后获取数据，
    //   // 此时 data 已经被 observed 了
    //   { immediate: true }
    // )
  },
  methods: {
    // fetchData() {
    //   this.error = this.post = null
    //   this.loading = true
    //   // replace `getPost` with your data fetching util / API wrapper
    //   getPost(this.$route.params.id, (err, post) => {
    //     this.loading = false
    //     if (err) {
    //       this.error = err.toString()
    //     } else {
    //       this.post = post
    //     }
    //   })
    // },
	getCaigou(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getCaigou'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.typelist == 0){
					this.caigoulist.push(resp)
				}
			})
		})   
	},
	getZhaobiao(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getZhaobiao'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.typelist == 1 && resp.status > 2){
					this.sandanlist.push(resp)
				}
			})
		})   
	},
	getBanners(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getBanner'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.type == 4){
					this.bannerTop.push(resp)
				}else if(resp.type == 5){
					this.bannerMiddle.push(resp)
				}
			})
		}) 
	},
	getDetails(){
			this.$axios({
				url:this.$utils.httpApi + 'Details/news',
				data:{id:this.id},
				method:'post'
			}).then(res=>{
				this.content = res.data.data
				this.metaName = this.content.title + '-' + this.title
			})  
	},
	handle(id){
		console.log(id);
		this.$router.push('/newsdetails/id/'+id)
	}
  },
}
</script>

<style scoped>
	.text{
		cursor: pointer;
		color:#409EFF;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.search{
		margin:10px auto;
	}
	.contentList{
		margin-top: 10px;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		/* width: 480px; */
	}	
	.listHeader{
		background-color: #409EFF;
		width:100%;
		height:40px;
		color:#fff;
		line-height: 40px;
		text-align: center;
		font-size: 1.1rem;
		font-weight: 700;
		margin-top: 10px;
	}
	.second{
		margin-bottom: 10px;
	}
	.title{
		text-align:center;
		font-size: 1.5rem;
		margin:10px auto;
	}
	.subtitle{
		margin:10px auto;
		text-align: center;
		color: #909399;
	}
	.details{
		margin-top: 20px;
		padding-bottom: 10px;
		border-bottom:1px solid #DCDFE6;
	}
	.tips{
		margin-top: 10px;
		font-size:0.8rem;
		color:#909399;
		
	}
	.tips span{
		color:red;
	}
</style>